import { render } from "./TextLink.vue?vue&type=template&id=21b6b04c&ts=true"
import script from "./TextLink.vue?vue&type=script&lang=ts"
export * from "./TextLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__